import React from "react";
import { MouseEvent } from "react";
import { Icon } from "../../Common/Icons/LucideIcons";
import { MapTool, MapToolControl } from "./__styles__/MapTools";
import { MapToolLabel } from "./MapToolLabel";

interface LegendControlProps {
  activeFloodLayerName?: string;
  handleLayersToggle?: (evt: MouseEvent | KeyboardEvent) => void;
}

export const LegendControlTool = ({
  activeFloodLayerName,
  handleLayersToggle,
}: LegendControlProps) => {
  return (
    <MapTool>
      {activeFloodLayerName && (
        <MapToolLabel
          label={activeFloodLayerName}
          permanent
          onClick={handleLayersToggle}
        />
      )}
      <MapToolControl
        data-testid="legendControl"
        styleVariant="outlineLight"
        onClick={handleLayersToggle}
        aria-label="Toggle Map Layers panel"
      >
        <Icon iconName="layers" color="contentPrimary" size={16} />
      </MapToolControl>
    </MapTool>
  );
};
